import {
    FailSummary,
    betFailSummarySliceActions,
} from '@/modules/report/slice/betFailSummary';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { CMDSpBetLogFailSummaryQuery, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDSpBetLogFailSummaryQueryHandler extends AbstractHandler {
    _command: CMDSpBetLogFailSummaryQuery;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpBetLogFailSummaryQuery;
    }
    handle(dispatch: Dispatch<AnyAction>): void {
        const summaries: FailSummary[] = [];
        for (let b of this._command.Bet) {
            const summary = {} as FailSummary;
            summary.TurnOverAmount = b.BetAmount;
            summary.ReportDate = b.ReportDate;
            summaries.push(summary);
        }

        dispatch(
            betFailSummarySliceActions.updateSummary({
                summaries: summaries.reverse(),
            })
        );
    }
}
